import { TextField } from '~/components/form';
import { KEY_DASH_HINT, toUnderscoreKey } from '~/lib/ai/keyFormat';

interface AssistantIdentityFieldsProps {
  name: string;
  assistantKey: string;
  onNameChange: (value: string) => void;
  onNameBlur: () => void;
  nameError?: string;
  /** Creating: the key is typed and required. Editing: it is shown read-only. */
  isNew: boolean;
  onKeyChange?: (value: string) => void;
  onKeyBlur?: () => void;
  keyError?: string;
}

/**
 * The Name and Assistant key fields (two cells of the page's grid), shared by
 * `/ai/digital-assistants/new` and the detail page's Details section.
 */
export default function AssistantIdentityFields({
  name,
  assistantKey,
  onNameChange,
  onNameBlur,
  nameError,
  isNew,
  onKeyChange,
  onKeyBlur,
  keyError,
}: AssistantIdentityFieldsProps) {
  return (
    <>
      <TextField
        id="digital-assistant-name"
        testId="digital-assistant-name"
        label="Name"
        required
        value={name}
        onChange={onNameChange}
        onBlur={onNameBlur}
        error={nameError}
        placeholder={isNew ? 'e.g. Listing caption writer' : undefined}
      />
      <TextField
        id="digital-assistant-key"
        testId="digital-assistant-key"
        label="Assistant key"
        required={isNew}
        code
        readOnly={!isNew}
        value={assistantKey}
        onChange={onKeyChange ?? (() => undefined)}
        transform={toUnderscoreKey}
        transformHint={KEY_DASH_HINT}
        onBlur={onKeyBlur}
        error={keyError}
        placeholder={isNew ? 'e.g. listing_caption' : undefined}
        helperText={
          isNew
            ? 'The API routes requests to this assistant by its key. It cannot be changed later.'
            : 'The API routes requests by this key. It cannot be changed.'
        }
      />
    </>
  );
}
